import { MAX_PAGE_SIZE } from './model';

export const ProjectFragmentQuery = `
fragment ProjectFragment on Project {
  id
  fullPath
  webUrl
  name
}
`;

export interface ProjectFragment {
  id: string;
  fullPath: string;
  webUrl: string;
  name: string;
}

export const IssueFragmentQuery = (validateNotes: boolean) => `
${ProjectFragmentQuery}
fragment IssueFragment on Issue {
  id
  projectId
  iid
  title
  state
  createdAt
  updatedAt
  webUrl
  labels {
    nodes {
      title
    }
  }
  totalTimeSpent
  timeEstimate
  notes(last: ${validateNotes ? MAX_PAGE_SIZE : 0}) {
    count
    nodes {
      id
      createdAt
      body
      author {
        id
        name
        webUrl
        username
        avatarUrl
      }
    }
  }
  timelogs (last: ${MAX_PAGE_SIZE}) {
    count
    nodes {
      id
      summary
      timeSpent
      spentAt
      user {
        id
        name
        webUrl
        username
        avatarUrl
      }
    }
  }
  milestone {
    title
    createdAt
    dueDate
  }
  linkedWorkItems {
    nodes{
      workItem{
        id
        iid
        title
        webUrl
        project{
          ...ProjectFragment
        }
      }
    }
  }
}
`;

export interface IssueFragment {
  id: string;
  projectId: string;
  iid: number;
  title: string;
  state: string;
  createdAt: string;
  updatedAt: string;
  webUrl: string;
  labels: {
    nodes:
      | {
          title: string;
        }[]
      | null;
  } | null;
  totalTimeSpent: number;
  timeEstimate: number;
  notes: {
    count: number;
    nodes: {
      id: string;
      createdAt: string;
      body: string;
      author: {
        id: string;
        name: string;
        webUrl: string;
        username: string;
        avatarUrl: string | null;
      };
    }[];
  };
  timelogs: {
    count: number;
    nodes:
      | {
          id: string;
          summary: string | null;
          timeSpent: number;
          spentAt: string;
          user: {
            id: string;
            name: string;
            webUrl: string;
            username: string;
            avatarUrl: string | null;
          };
        }[]
      | null;
  };
  milestone: {
    title: string;
    createdAt: string;
    dueDate: string | null;
  } | null;
  linkedWorkItems: {
    nodes:
      | {
          workItem: {
            id: string;
            iid: number;
            title: string;
            webUrl: string;
            project: ProjectFragment;
          };
        }[]
      | null;
  } | null;
}
